export { default as DocumentVideoSolidIcon } from './DocumentVideoSolidIcon';
